import { Encounter, DiagnosticReport } from "@medplum/fhirtypes";
import { SidePanelContent } from "../../side-panel/side-panel-content";
import { ReportRowData } from "./table-data";
import { ReportContent as Content } from "./report-content";
import { MappedConsolidatedResources } from "../../../shared-logic/consolidated-context/reducer";
import { ReferencesDisplay } from "../shared/references";
import { NoteClassification } from "./note-classification";

export function ReportContent({
  mappedConsolidated,
  isImpersonating,
  ...rowContents
}: {
  isImpersonating?: boolean;
  mappedConsolidated: MappedConsolidatedResources | undefined;
} & ReportRowData) {
  const selectedEncounter = mappedConsolidated?.["Encounter"]?.[
    rowContents.report.encounter.id ?? ""
  ] as Encounter | undefined;
  const selectedDiagnosticReport = mappedConsolidated?.["DiagnosticReport"]?.[
    rowContents.report.diagnosticReports[0]?.id ?? ""
  ] as DiagnosticReport | undefined;

  const selectedResource = selectedEncounter ?? selectedDiagnosticReport;

  const valueString =
    (selectedResource?.meta?.source ||
      selectedResource?.extension?.find(ext => ext.valueString)?.valueString) ??
    "";

  return (
    <SidePanelContent
      title="Note"
      sourceDocument={{
        id: selectedResource?.id ?? "",
        fileName: valueString,
      }}
      fhirJson={isImpersonating ? JSON.stringify(selectedEncounter, null, 2) : undefined}
    >
      <NoteClassification
        noteCategory={rowContents.noteCategory}
        specialty={rowContents.specialty}
        typeOfReport={rowContents.typeOfReport}
      />

      <Content encounterNote={rowContents.report} />
      <ReferencesDisplay
        encounters={{
          refs: selectedEncounter ? [selectedEncounter] : undefined,
        }}
        locations={{
          refs: rowContents.report.locations,
        }}
        practitioners={{
          refs: rowContents.report.participants,
        }}
        conditions={{
          refs: rowContents.report.diagnoses,
        }}
      />
    </SidePanelContent>
  );
}
